module.exports = __webpack_public_path__ + "img/yishi5.de4c452c.jpg";